export default {
  client: null,
  user: (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))) || null,
  partner: (localStorage.getItem("partner") && JSON.parse(localStorage.getItem("partner"))) || null,
};